export const ADMIN_TOKEN_KEY = "auth_token";
